module.exports = __webpack_public_path__ + "static/media/spring-cleanup.093cbe54.jpg";